import { FamilyGraphSchema, type FamilyGraph, type FamilyPerson } from "./obituary-intestacy.js";

/**
 * Indented text family tree from a source-cited familyGraph.
 * Not a legal heirship opinion.
 */
export function renderFamilyTreeText(graphInput: unknown): string {
  const graph = FamilyGraphSchema.parse(graphInput);
  const decedent = graph.decedentName?.trim() || "Decedent";
  const death = graph.deathDate ? ` (died ${graph.deathDate})` : "";
  const roots = graph.persons.filter((person) => !person.parentBranchId);
  const lines = [`${decedent}${death}`];
  roots.forEach((person, index) => {
    walk(graph, person, "", index === roots.length - 1, lines);
  });
  if (graph.extractionLimitations.length) {
    lines.push("", "Limitations:");
    for (const limitation of graph.extractionLimitations) lines.push(`- ${limitation}`);
  }
  return lines.join("\n");
}

function walk(
  graph: FamilyGraph,
  person: FamilyPerson,
  prefix: string,
  last: boolean,
  lines: string[]
): void {
  const branch = last ? "└─ " : "├─ ";
  const childPrefix = prefix + (last ? "   " : "│  ");
  lines.push(`${prefix}${branch}${person.relationship}: ${person.name} (${survival(person.survival)})`);
  const children = graph.persons.filter((candidate) => candidate.parentBranchId === person.id);
  children.forEach((child, index) => {
    walk(graph, child, childPrefix, index === children.length - 1, lines);
  });
}

function survival(value: FamilyPerson["survival"]): string {
  if (value === "apparently_survived") return "survived";
  if (value === "apparently_predeceased") return "predeceased";
  return "unknown";
}
